import { ChangeDetectorRef, Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[checklistComponentHost]',
})
export class QuarterCloseChecklistDirective {
  changeDetectorRef = inject(ChangeDetectorRef);
  viewContainerRef = inject(ViewContainerRef);
}
